"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorage = exports.getLocalStorage = exports.isLocalStorageAvailable = void 0;
var InMemoryStorageAdapter_1 = require("./InMemoryStorageAdapter");
/**
 * An empty storage implementation, where everything is a no-op.
 */
var emptyStorage = {
    length: 0,
    clear: function () { return undefined; },
    getItem: function () { return null; },
    key: function () { return null; },
    removeItem: function () { return undefined; },
    setItem: function () { return undefined; },
};
/**
 * Tries to detect if a storage implementation is available by writing/reading from it and tracking the result or error.
 */
function isLocalStorageAvailable() {
    try {
        var uid = new Date().toString();
        window.localStorage.setItem(uid, uid);
        var result = window.localStorage.getItem(uid) === uid;
        window.localStorage.removeItem(uid);
        return result;
    }
    catch (err) {
        return false;
    }
}
exports.isLocalStorageAvailable = isLocalStorageAvailable;
/**
 * Returns the current origin's localStorage instance if available, or a do-nothing implementation when not available.
 */
function getLocalStorage() {
    if (typeof window !== "undefined" && isLocalStorageAvailable()) {
        return window.localStorage;
    }
    else {
        return emptyStorage;
    }
}
exports.getLocalStorage = getLocalStorage;
exports.localStorage = new InMemoryStorageAdapter_1.InMemoryStorageAdapter(getLocalStorage());
